import { contactInfo } from '@/mocks/homeData';

export default function FloatingWhatsApp() {
  return (
    <a
      href={`https://wa.me/${contactInfo.whatsapp}?text=Olá!%20Gostaria%20de%20agendar%20uma%20avaliação%20com%20a%20Dra.%20Marihana.`}
      target="_blank"
      rel="nofollow noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-[#25D366] text-white rounded-full whatsapp-pulse cursor-pointer hover:scale-110 transition-transform duration-300"
      aria-label="Falar no WhatsApp"
    >
      <i className="ri-whatsapp-line text-xl md:text-2xl"></i>
    </a>
  );
}